import React from 'react';
import './Accueil.css';
import Hero from './components/Hero';
import TextWithImage from './components/TextWithImage';
import FeaturedProducts from './components/FeaturedProducts';
import FeatureBar from './components/FeatureBar';
import ImageCarousel from '../../components/ImageCarousel/ImageCarousel';

// --- MODIFICATION : Import de toutes vos nouvelles images d'inspiration ---

// Images "autre"
import autre1 from '../../assets/images/divers/autre/i1.jpg';
import autre2 from '../../assets/images/divers/autre/i2.jpg';
import autre3 from '../../assets/images/divers/autre/i3.jpg';
import autre4 from '../../assets/images/divers/autre/i4.jpg';
import autre5 from '../../assets/images/divers/autre/i5.jpg';
import autre6 from '../../assets/images/divers/autre/i6.jpg';
import autre7 from '../../assets/images/divers/autre/i7.jpg';

// Images "paysage"
import paysage1 from '../../assets/images/divers/paysage/g1.jpg';
import paysage2 from '../../assets/images/divers/paysage/g2.jpg';
import paysage3 from '../../assets/images/divers/paysage/g3.jpg';
import paysage4 from '../../assets/images/divers/paysage/g4.jpg';
import paysage5 from '../../assets/images/divers/paysage/g5.jpg';
import paysage6 from '../../assets/images/divers/paysage/g6.jpg';
import paysage7 from '../../assets/images/divers/paysage/g7.jpg';
import paysage8 from '../../assets/images/divers/paysage/g8.jpg';
import paysage9 from '../../assets/images/divers/paysage/g9.jpg';
import paysage10 from '../../assets/images/divers/paysage/g10.jpg';
import paysage11 from '../../assets/images/divers/paysage/g11.jpg';
import paysage12 from '../../assets/images/divers/paysage/g12.jpg';
import paysage13 from '../../assets/images/divers/paysage/g13.jpg';
import paysage14 from '../../assets/images/divers/paysage/g14.jpg';
import paysage15 from '../../assets/images/divers/paysage/g15.jpg';

// Images "perle"
import perle1 from '../../assets/images/divers/perle/p1.jpg';
import perle2 from '../../assets/images/divers/perle/p2.jpg';
import perle3 from '../../assets/images/divers/perle/p3.jpg';
import perle4 from '../../assets/images/divers/perle/p4.jpg';
import perle5 from '../../assets/images/divers/perle/p5.jpg';
import perle6 from '../../assets/images/divers/perle/p6.jpg';
import perle7 from '../../assets/images/divers/perle/p7.jpg';
import perle8 from '../../assets/images/divers/perle/p8.jpg';
import perle9 from '../../assets/images/divers/perle/p9.jpg';
import perle10 from '../../assets/images/divers/perle/p10.jpg';
import perle11 from '../../assets/images/divers/perle/p11.jpg';

// Nouvelles images pour les sections TextWithImage
import keishiImage from '../../assets/images/divers/perle/keishi.jpeg'; // Exemple d'image pour Keishi
import storyImage from '../../assets/images/divers/paysage/g11.jpg'; // Exemple d'image pour l'histoire
import careImage from '../../assets/images/divers/perle/p2.jpg'; // Exemple d'image pour les conseils d'entretien


function Accueil() {
  const keishiText = `
    <p>On connait bien la perle de culture de Tahiti mais connaissez-vous les keishis(keshis)?</p>
    <p>Laissez-moi vous parler de poésie…</p>
    <p>Ces petits morceaux de nacre symbolisent le mythe de la perle ! Nés sans la volonté humaine, c’est un miracle de la nature, une jolie surprise, un petit grain…de folie, issus de l’huître perlière. Ces jolies nacres pures, sans noyaux, libres, aux formes surprenantes, je les travaille en bijoux très fins ou hyper originaux.</p>
  `;

  const storyText = `
    <p>3 ans de réflexion… 3 ans pour naître !</p>
    <p>Après 3 ans passés en Polynésie française, laissez-moi vous présenter petite Poe(perle en tahitien) dont l’histoire se mêle à la mienne et grâce à qui je vous propose mes créations…</p>
    <p>Voici ce qu’elle raconte :</p>
    <p><em>« Je commence mon voyage comme petit nucléus de nacre greffé dans le manteau protecteur d’une huître perlière élevée spécialement pour moi depuis déjà 18 mois où elle me fait grandir, m’enrobe de nacre, bien au chaud dans les profondeurs d’un lagon nourricier du sud pacifique. On me surveille, on me protège et on m’espère pendant encore de longs mois et enfin je vois le jour. Petite Poe, je suis une surprise totale, naturelle, nul ne connaît ma forme, ma couleur et mon lustre… Et pourtant, je suis déjà si spéciale, si particulière... C’est au bout de ce long voyage que je suis enfin choisie, associée, montée en fonction de ma personnalité pour faire un bijou unique pour une personne unique… J’ai hâte de vous rencontrer »</em></p>
    <p><strong>Magali, Créatrice de Couleur Sirène</strong></p>
  `;

  const careText = `
    <p>Nos bijoux en acier inoxydable et perles de Tahiti sont montés de façon artisanale dans nos ateliers, par Magali la créatrice de Couleur Sirène.</p>
    <p>Ils doivent être choyés arrivés chez vous.</p>
    <p>Les perles sont précieuses et sensibles, ainsi nous vous conseillons de les enlever pour dormir, pour les tâches ménagères, pour jardiner, pour aller à la piscine… Les bijoux craignent les rayures, les chocs.</p>
    <p>Vous pouvez les entretenir et les lustrer avec un chiffon sec et doux. Il est fortement recommandé de les ranger avec précaution, sans les plier, idéalement dans une boîte à bijoux !</p>
  `;

  // MODIFICATION : On remplit le tableau avec les vraies images
  const carouselImages = [
    { src: paysage1, alt: 'Paysage de lagon polynésien' },
    { src: perle1, alt: 'Gros plan sur une perle de Tahiti' },
    { src: autre1, alt: 'Ambiance tropicale' },
    { src: paysage2, alt: 'Vue de bungalows sur l\'eau' },
    { src: perle2, alt: 'Perles de Tahiti brutes' },
    { src: autre2, alt: 'Fleur de Tiaré' },
    { src: paysage3, alt: 'Coucher de soleil sur l\'océan' },
    { src: perle3, alt: 'Main tenant une perle Keishi' },
    { src: autre3, alt: 'Détail de nacre' },
    { src: paysage4, alt: 'Plage de sable blanc' },
    { src: perle4, alt: 'Perle dans son huître' },
    { src: autre4, alt: 'Coquillages sur le sable' },
    { src: paysage5, alt: 'Atoll de Polynésie' },
    { src: perle5, alt: 'Collier de perles de Tahiti' },
    { src: autre5, alt: 'Poisson tropical' },
    { src: paysage6, alt: 'Récif corallien' },
    { src: perle6, alt: 'Bracelet avec perles de Tahiti' },
    { src: autre6, alt: 'Vagues sur la plage' },
    { src: paysage7, alt: 'Montagne et lagon' },
    { src: perle7, alt: 'Boucles d\'oreilles keishi' },
    { src: autre7, alt: 'Coucher de soleil' },
    { src: paysage8, alt: 'Bateau dans le lagon' },
    { src: perle8, alt: 'Perles de Tahiti aux couleurs variées' },
    { src: paysage9, alt: 'Palmmiers sur la plage' },
    { src: perle9, alt: 'Bijoux en perles keishi' },
    { src: paysage10, alt: 'Paysage sous-marin' },
    { src: perle10, alt: 'Pendentif perle de Tahiti' },
    { src: paysage11, alt: 'Ponton sur l\'eau' },
    { src: perle11, alt: 'Perles rondes et baroques' },
    { src: paysage12, alt: 'Plage déserte' },
    { src: paysage13, alt: 'Lagon turquoise' },
    { src: paysage14, alt: 'Plongée avec les poissons' },
    { src: paysage15, alt: 'Île vue du ciel' },
  ];

  return (
    <div className="accueil-page">
      <Hero />
      <div className="page-content-wrapper">

      <TextWithImage
          title="Couleur Sirène, toute une histoire..."
          text={storyText}
          image={storyImage} // Ajout de l'image pour cette section
          imageSide="left"
          buttonLink="/a-propos"
          buttonText="En savoir plus"
        />

        <FeaturedProducts />

        <TextWithImage
          title="Keishi, vous avez dit Keshi ?"
          text={keishiText}
          image={keishiImage} // Ajout de l'image pour cette section
          imageSide="right"
        />

      </div> {/* Fin de page-content-wrapper pour les sections précédentes */}

      {/* La section du carrousel prend maintenant toute la largeur */}
      <section className="carousel-section full-width-section">
        {/* Le titre est maintenant directement dans la section, avant le carrousel */}
        <h2>Inspirations</h2>
        <ImageCarousel images={carouselImages} />
      </section>

      {/* Le reste du contenu reprend un page-content-wrapper si nécessaire */}
      <div className="page-content-wrapper">
        <TextWithImage
          title="Conseils d'entretien"
          text={careText}
          image={careImage} // Ajout de l'image pour cette section
          imageSide="right"
        />

        <FeatureBar />


      </div>
    </div>
  );
}

export default Accueil;